export enum AlertActions {
  navigateHome,
};

export enum SideBarContent {
  chat,
  appointment,
};

export enum ModalContent {
  settings,
};

export type ToggleSidebar = {
  sidebar: SideBarContent;
  value?: boolean;
}

export type ToggleModal = {
  modal: ModalContent;
  value?: boolean;
}

export enum AlertTypes {
  error,
  success
}

export type Alert = {
  visible: boolean;
  title: string;
  message: string;
  url?: string;
  action?: AlertActions;
  type?: AlertTypes;
};

export interface IUiState {
  isDarkMode: boolean;
  sidebar: SideBarContent | null;
  modal: ModalContent | null;
  alert: Alert | null;
  pinnedSizes: {
    width: number;
    height: number;
  } | null;
};
